import { Moment, isMoment } from 'moment';

export const getOnDateChange = (
  setDate: (date: string) => void,
  setHasSelectedDate: (hasSelectedDate: boolean) => void,
) => {
  return (datePickerDate: string | Moment) => {
    setHasSelectedDate(true);
    if (isMoment(datePickerDate)) setDate(datePickerDate.toISOString());
    else return setDate(datePickerDate);
  };
};
